export default {
  meta: {
    title: '门店地图',
  },
};
